import { NOTICE_KINDS as e } from "../notice/notice-constants.js";
//#region components/toast/toast_constants.js
var t = ["gradient", ...e], n = ["status", "alert"], r = 6e3, i = ["default", "alternate"], a = {
	TOAST_ROLES: n,
	TOAST_MIN_DURATION: r,
	TOAST_LAYOUTS: i,
	TOAST_ALTERNATE_KINDS: t
};
//#endregion
export { t as TOAST_ALTERNATE_KINDS, i as TOAST_LAYOUTS, r as TOAST_MIN_DURATION, n as TOAST_ROLES, a as default };

//# sourceMappingURL=toast-constants.js.map